export var sendAndSaveInfobarIdsToRemove = [
    /* WASCL related messages */
    'errorMessageAccountSuspend',
    'errorMessageAccountSuspendShowTierUpgrade',
    'errorMessageExceededHourlyMessageLimit',
    'errorMessageExceededMaxRecipientLimit',
    'errorMessageExceededMaxRecipientLimitShowTierUpgrade',
    'errorMessageExceededMessageLimit',
    'errorMessageExceededMessageLimitShowTierUpgrade',
    'errorMessageMessageSubmissionBlocked',
    'errorMessageMessageBlocked',
    'errorMessageTimeout',
    'errorMessageThrottled',
    'errorMessageTransientError',
    /* The message can't be saved or sent because the item is no longer existed*/
    'errorMessageItemNoLongerExistToSave',
    'errorMessageItemNoLongerExistToSend',
    /* Send/Save failure for mailbox full case */
    'errorMessageQuotaExceededMessageCanNotBeSaved',
    'errorMessageQuotaExceededMessageCanNotBeSent',
    /* specific message for the throttling policy case, i.e. when daily RecipientRateLimit is exceeded */
    'errorMessageSubmissionQuotaExceededMessageCanNotBeSent',
    /* misc */
    'errorMessageMessageCanNotBeSaved',
    'errorMessageMessageCanNotBeSent',
    'errorMessageNoPermissionToSendAs',
    'errorMessageNoRecipentsMailCanNotBeSend',
    'warningMessageMaxRecipientsExceed',
    'warningMessageNoPermissionToPerformAction',
    'warningNoQuotedBody',
    'error500',
    'error503',
    'errorFailedToFetch',
    'errorSessionTimeout',
    'errorMailboxStoreUnavailable',
    'errorMessageErrorWithDetail',
];
//# sourceMappingURL=InfoBarMessageId.js.map